export const DISPLAY_GSTIN                : string = "DISPLAY_GSTIN"
export const UPDATE_SOURCE_AS_GSTIN       : string = "UPDATE_SOURCE_AS_GSTIN"
export const UPDATE_REVIEWS_DATA          : string = "UPDATE_REVIEWS_DATA"
export const UPDATE_TRAVELLER_ERROR       : string = "UPDATE_TRAVELLER_ERROR"
export const CLEAR_REVIEW_DATA            : string = "CLEAR_REVIEW_DATA"
export const UPDATE_POPUP_RESPONSE        : string = "UPDATE_POPUP_RESPONSE"
export const UPDATE_LOADER_STATE          : string = "UPDATE_LOADER_STATE"
export const UPDATE_REVIEW_SELECTED_DATA  : string = "UPDATE_REVIEW_SELECTED_DATA"
export const UPDATE_FARE_DETAILS          : string = "UPDATE_FARE_DETAILS"
export const UPDATE_REVIEW_RESPONSE       : string = "UPDATE_REVIEW_RESPONSE"
export const UPDATE_SELECTED_ADDONS       : string = "UPDATE_SELECTED_ADDONS"
export const UPDATE_SELECTED_LANGUAGE     : string = "UPDATE_SELECTED_LANGUAGE"